import { useCallback, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { getLegalCategories } from "../../lib/legalAdmin";
import CategoryCard from "./legal/CategoryCard";
import AdminNav from "../../components/AdminNav";

// M2 Slice 9 — Super Admin legal documents page (documents only: publish current versions).
export default function LegalAdmin() {
  const { profile } = useAuth();
  const [categories, setCategories] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      setCategories(await getLegalCategories());
    } catch (e) {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  // Belt-and-suspenders in-page guard, consistent with other Super Admin pages.
  if (profile && profile.role !== "SUPER_ADMIN") return <Navigate to="/app" replace />;

  return (
    <>
    <div className="max-w-[1600px] mx-auto px-6 pt-6"><AdminNav /></div>
    <div className="max-w-[960px] mx-auto p-6" data-testid="legal-admin-page">
      <div className="flex items-baseline justify-between mb-6">
        <div>
          <div className="overline">DOCUMENTS</div>
          <h1 className="heading text-3xl">Legal</h1>
        </div>
      </div>

      {loading ? (
        <div className="mono text-sm" data-testid="legal-loading">Loading…</div>
      ) : error ? (
        <div className="grid-card p-4 border-l-2 border-[hsl(var(--danger))]" data-testid="legal-load-error">
          <div className="flex items-center justify-between gap-4">
            <p className="text-sm">We couldn’t load the legal categories right now. Please try again.</p>
            <button className="btn-ghost shrink-0" onClick={load} data-testid="legal-load-retry">Retry</button>
          </div>
        </div>
      ) : (
        <div className="space-y-4" data-testid="legal-categories">
          {(categories || []).map((cat) => (
            <CategoryCard key={cat.category_key} category={cat} onRefresh={load} />
          ))}
        </div>
      )}
    </div>
    </>
  );
}
